const trustItems = [
  {
    icon: 'ri-shield-check-fill',
    title: 'Licensed & Insured',
    subtitle: 'Certified for Roofing, Solar & General Contracting',
  },
  {
    icon: 'ri-home-heart-line',
    title: 'Family-Owned & Operated',
    subtitle: 'Locally Rooted in Campbell, CA',
  },
  {
    icon: 'ri-sun-fill',
    title: 'Roofing + Solar Specialists',
    subtitle: 'Complete Exterior Solutions for South Bay Homes',
  },
  {
    icon: 'ri-time-line',
    title: 'Mon – Sat, 7am – 6pm',
    subtitle: 'Responsive Service, Efficient Timelines',
  },
];

export default function TrustBar() {
  return (
    <section className="border-b border-white/5" style={{ background: '#0a1520' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {trustItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-6 py-7 ${idx < trustItems.length - 1 ? 'lg:border-r border-white/[0.07]' : ''} ${idx < 2 ? 'sm:border-b lg:border-b-0 border-white/[0.07]' : ''}`}
            >
              <div
                className="w-11 h-11 flex items-center justify-center rounded-full flex-shrink-0"
                style={{ background: 'rgba(212,175,55,0.1)' }}
              >
                <i className={`${item.icon} text-[#d4af37] text-lg`}></i>
              </div>
              <div>
                <p
                  className="text-white font-bold text-sm leading-snug"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {item.title}
                </p>
                <p
                  className="text-white/35 text-xs mt-0.5 leading-snug"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {item.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
